import type { ReactNode } from 'react';

type Props = {
  id?: string;
  label?: string;
  title: string;
  lead?: string;
  children: ReactNode;
  className?: string;
};

export function Section({ id, label, title, lead, children, className = '' }: Props) {
  return (
    <section id={id} className={`section ${className}`.trim()}>
      <div className="container">
        {label ? <span className="section-label">{label}</span> : null}
        <h2 className="section-title">{title}</h2>
        {lead ? <p className="section-lead">{lead}</p> : null}
        {children}
      </div>
    </section>
  );
}
